(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('HomepageController', HomepageController)

	/** @ngInject */
	function HomepageController($q, $state, $rootScope, $timeout, CouponService, HelperService, NotifyService, UserService, sweetAlert, DATA_EVENTS) {
		const vm = this;
		var scanner;
		let scannerConfig = {
			fps: 10,
		}

		let couponModal = new bootstrap.Modal($("#coupon-modal"), {
			keyboard: false,
			backdrop: 'static'
		});

		$(couponModal).on('hidden.bs.modal', function (event) {
			vm.showRescue = false;
			vm.openCouponData = null;
			vm.validated = false;
		})

		let perPageCoupon = 10;
		let currentPageCoupon = 0;
		let currentPageSearchCoupon = 0;

		let removeWatchDoSearch = $rootScope.$on(DATA_EVENTS.DO_SEARCH, () => searchCupons());
		let removeWatchOpenSearch = $rootScope.$on(DATA_EVENTS.OPEN_SEARCH, () => {
			vm.searchTerm = CouponService.getSearchTerm();
			vm.showSearchArea = true;
			vm.couponsSearch = [];
		});
		let removeWatchClose = $rootScope.$on(DATA_EVENTS.CLOSE_SEARCH, () => {
			vm.searchTerm = CouponService.getSearchTerm();
			vm.showSearchArea = false;
			vm.couponsSearch = [];
		});

		vm.caminhoPastaImagem = (area, id, arquivo) => HelperService.caminhoPastaImagem(area, id, arquivo);

		vm.rescue = coupon => {
			vm.showRescue = true;
			vm.openCouponData = coupon;

			couponModal.show();
		}

		vm.closeRescue = () => {
			couponModal.hide();
			vm.closeRescueWindow();
		}

		vm.loadMoreLowCoupon = () => {
			currentPageCoupon++;

			getLowCoupons(true);
		}

		vm.loadMoreSearchCoupon = () => {
			currentPageSearchCoupon++;

			searchCupons(true);
		}

		vm.changeCategory = categoryId => {
			vm.currentCategory = categoryId;
			console.log('vm.currentCategory: ', vm.currentCategory);
			getLowCoupons();
		}

		vm.closeRescueWindow = () => {

			vm.showRescueWindow = false;
			vm.couponBusinessCode = "";
			vm.writeCode = false;
			vm.cannotScan = false;
		}

		vm.openRescueWindow = () => {
			vm.showRescueWindow = true;
			startScanner();
		}

		vm.submitWritedCode = () => {
			if (!vm.couponBusinessCode) {
				NotifyService.error("Ops,", "Você deve digitar o código da empresa.");
				return;
			}

			validateCoupon(vm.couponBusinessCode.toUpperCase());
		}

		vm.openWriteCode = () => {
			vm.writeCode = true;
			$timeout(() => document.getElementById("couponBusinessCode").focus(), 100);
		}

		init();

		function validateCoupon(businessCode) {
			if (!vm.isLogged) {
				sweetAlert.swal({
					title: "Ops,",
					type: 'error',
					text: "Você deve fazer login para resgatar o cupom!",
					confirmButtonText: "Ir para login",
					cancelButtonText: "Fechar",
					showCancelButton: true,
					allowOutsideClick: false,
					allowEscapeKey: false,
					allowEnterKey: false
				}).then(action => {
					if (action) {
						couponModal.hide();
						$state.go("app.login");
					}
				}).catch(() => startScanner())
				return;
			}

			HelperService.startLoading(".content-body");

			businessCode = businessCode.replace("\n", "");

			useCoupon(businessCode)
				.then(
					success => {
						if (!success.errors && success.coupon_id) {
							vm.validated = true;
							HelperService.stopLoading(".content-body");

							NotifyService
								.notify({
									title: "Cupom validado!",
									type: "success",
									text: "Aproveite sua oferta exclusiva!",
									confirmButtonText: "Fechar",
									cancelButtonText: "Ver meus cupons",
									showCancelButton: true,
									allowOutsideClick: false,
									allowEscapeKey: false,
									allowEnterKey: false,
									reverseButtons: true
								}, action => {
									if (action == true)
										vm.closeRescue();
								}, cancel => {
									$timeout(() => $state.go("auth.my-rescues"), 100)
									$timeout(() => closeScan(), 100)
									vm.closeRescue();
								})
						} else {
							HelperService.stopLoading(".content-body");
							HelperService.errorCallback(success);
						}
					}, error => {
						HelperService.stopLoading(".content-body");
						HelperService.errorCallback(error);
					}
				)
		}

		function closeScan() {
			if (scanner)
				scanner.stop();
		}

		function startCamera() {
			$timeout(() => vm.cannotScan = true, 10000);

			scanner
				.start(
					{ facingMode: "environment" },
					scannerConfig,
					(decodedText, decodedResult) => {
						validateCoupon(decodedText)
						scanner.stop();
						return;
					})
				.catch(err => NotifyService.error("Erro!", err));
		}

		function startScanner() {
			Html5Qrcode
				.getCameras()
				.then(devices => {
					if (devices && devices.length) {
						scanner = new Html5Qrcode("preview");

						startCamera();
					}
				}).catch(err => $timeout(() => vm.cannotUseCamera = true, 100));
		}

		function useCoupon(businessCode) {
			let params = {
				coupon_id: vm.openCouponData.id,
				business_code: businessCode,
				user_id: UserService.getUserId()
			};

			return CouponService.use(params);
		}

		function getHighCoupons() {
			return CouponService
				.getByParameters({
					priorityId: 1,
					orderDescending: true
				})
				.then(
					success => vm.couponsHigh = success.Registers,
					error => HelperService.errorCallback(error)
				)
		}

		function getMediumCoupons() {
			return CouponService
				.getByParameters({
					priorityId: 2,
					orderDescending: true
				})
				.then(
					success => vm.couponsMedium = success.Registers,
					error => HelperService.errorCallback(error)
				)
		}

		function getLowCoupons(append = false) {
			let params = {
				perPage: perPageCoupon,
				skip: currentPageCoupon * perPageCoupon,
				orderBy: "business_name",
				orderDescending: false
			};

			if (vm.currentCategory) {
				params.category = vm.currentCategory;
			}

			return CouponService
				.getByParameters(params)
				.then(
					success => {
						if (!success.errors) {
							if (append == true) {
								vm.couponsLow = vm.couponsLow.concat(success.Registers)
							} else {
								vm.couponsLow = success.Registers
							}
						} else {
							if (success.errors.type == "no_content")
								vm.canLoadMoreLowCoupon = false;
							else
								HelperService.errorCallback(success);
						}


						if (success.Registers.length < perPageCoupon)
							vm.canLoadMoreLowCoupon = false;
						else if (currentPageCoupon == success.NumberOfPages - 1)
							vm.canLoadMoreLowCoupon = false;
						else
							vm.canLoadMoreLowCoupon = true;
					},
					error => HelperService.errorCallback(error)
				)
		}

		function getCategories() {
			return CouponService
				.getCategoriesByParameters({
					active: true
				})
				.then(
					success => {
						vm.categories = success.Registers;
						vm.categories.unshift({
							"id": "",
							"name": "Todas as categorias",
						});
						vm.currentCategory = 0;
					},
					error => HelperService.errorCallback(error)
				)
		}

		function searchCupons(append = false) {
			vm.showSearchArea = true;
			vm.searchTerm = CouponService.getSearchTerm();

			let params = {
				perPage: perPageCoupon,
				skip: currentPageSearchCoupon * perPageCoupon,
				searchField: ["coupon.title", "coupon.description", "business.name"],
				searchQuery: vm.searchTerm,
				orderBy: "business_name",
				orderDescending: false
			};

			return CouponService
				.getByParameters(params)
				.then(
					success => {
						if (!success.errors) {
							if (append == true) {
								vm.couponsSearch = vm.couponsSearch.concat(success.Registers)
							}
							else {
								vm.couponsSearch = success.Registers
							}
						} else {
							if (success.errors.type == "no_content")
								vm.canLoadMoreSearchCoupon = false;
							else
								HelperService.errorCallback(success);
						}

						if (success.Registers.length < perPageCoupon || success.Registers.length == 0)
							vm.canLoadMoreSearchCoupon = false;
						else if (currentPageSearchCoupon == success.NumberOfPages - 1)
							vm.canLoadMoreSearchCoupon = false;
						else
							vm.canLoadMoreSearchCoupon = true;
					},
					error => HelperService.errorCallback(error)
				)
		}

		function init() {
			HelperService.startLoading(".content-body");
			vm.isLogged = UserService.isLogged();

			vm.breakpointsHigh = {
				768: {
					slidesPerView: 1,
					spaceBetween: 15
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 15
				},
				1920: {
					slidesPerView: 3,
					spaceBetween: 15
				}
			}

			vm.breakpointsMedium = {
				400: {
					slidesPerView: 2,
					spaceBetween: 15
				},
				1920: {
					slidesPerView: 3,
					spaceBetween: 15
				}
			}

			vm.showRescue = true;
			vm.canLoadMoreLowCoupon = false;
			vm.canLoadMoreSearchCoupon = false;
			vm.writeCode = false;
			vm.cannotUseCamera = false;
			vm.cannotScan = false;

			var swiperCategories = new Swiper("#swiperCategories", {
				slidesPerView: "auto",
				spaceBetween: 10,
				freeMode: true,
			});

			$q.all([
				getHighCoupons(),
				getMediumCoupons(),
				getLowCoupons(),
				getCategories()
			]).then(
				success => {
					HelperService.stopLoading(".content-body");
				}, error => {
					console.log('error: ', error);
					HelperService.errorCallback(error);
					HelperService.stopLoading(".content-body");
				}
			)

		}
	}
}());